<template>
  <div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard ref="wizard"
                       title="Thank you for your Registration"
                       subtitle=" "
                       color='#31bebf'>
  
            <tab-content title=" "
                         icon="ti-user">
                <div class="row">
                    <div class="col-md-10 col-md-offset-1">
                        <h4 class="text-center">
                            {{ translatedFields['congratulation_your_test_is_registered'] }}
                        </h4>
                        <h5 class="text-center">
                            {{ translatedFields['here_is_your_confirmation_number'] }}: <span class="htrx-secondary">{{ conformationNumber }}</span>
                        </h5>
                        <h5>
                            {{ translatedFields['please_screenshot_your_confirmation_number_as_you_will_need_it_when_you_revisit_this_site_to_check_for_your_results'] }}
                        </h5>

                        <h4>
                            {{ translatedFields['your_next_steps'] }}:
                        </h4>
                        <ol>
                            <li>
                                <h5>
                                    {{ translatedFields['now_that_your_test_is_registered_with_us_please_check_your_email_for_your_confirmation_number_or_screenshot_this_screen'] }}
                                </h5>
                            </li>
                            <li>
                                <h5>{{ translatedFields['click'] }}
                                    <router-link to="/patient/check-results" class="htrx-secondary">{{ translatedFields['here'] }}</router-link>
                                    {{ translatedFields['for_instructions_on_how_to_collect_and_send_your_sample_to_us'] }}
                                </h5>
                            </li>
                            <li>
                                <h5>
                                    IMPT: {{ translatedFields['do_not_collect_your_sample_on_a_saturday_or_sunday_as_shipping_services_do_not_operate_on_the_weekends'] }}
                                </h5>
                            </li>
                            <li>
                                <h5>{{ translatedFields['click'] }}
                                    <a href="https://www.ups.com/dropoff/?loc=en_US" class="here">{{ translatedFields['here'] }}</a>
                                    {{ translatedFields['or_scan_the_code_below_to_locate_the_ups_drop_off_location_nearest_you'] }}
                                </h5>
                            </li>
                        </ol>
                    </div>
                </div>
            </tab-content>
            <template class="d-none here" slot="footer">
                Thank you!
            </template>
          </form-wizard>
          <br><br>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        conformationNumber: '',
        fields_en: {
          congratulation_your_test_is_registered: 'Congratulation, your test is registered!',
          here_is_your_confirmation_number: `Here's your confirmation number`,
          please_screenshot_your_confirmation_number_as_you_will_need_it_when_you_revisit_this_site_to_check_for_your_results: `Please screenshot your confirmation number as you'll need it when you revisit this site to check for your results`,
          your_next_steps: 'Your next steps',
          now_that_your_test_is_registered_with_us_please_check_your_email_for_your_confirmation_number_or_screenshot_this_screen: 'Now that your test is registered with us, please check your email for your confirmation number or screenshot this screen',
          click: 'Click',
          here: 'here',
          for_instructions_on_how_to_collect_and_send_your_sample_to_us: 'for instructions on how to collect and send your sample to us',
          do_not_collect_your_sample_on_a_saturday_or_sunday_as_shipping_services_do_not_operate_on_the_weekends: 'Do not collect your sample on a Saturday or Sunday as shipping services do not operate on the weekends',
          or_scan_the_code_below_to_locate_the_ups_drop_off_location_nearest_you: 'or scan the code below to locate the UPS drop off location nearest you'
        }
      }
    },
    mounted: function () {
      this.conformationNumber = this.$route.params.id
    },
    methods: {
      nextTab () {
        this.$refs.wizard.nextTab()
      },
      jumpToTheNextPage () {
        // this method will jump to the next page without any validation
        // do not use it
        this.$refs.wizard.changeTab(0, 1)
      },
      checkLanguage () {
        if (this.$store.state.lang.value === 'ES') {
          this.translatedFields = this.$store.state.translation_es
        } else {
          if (this.$store.state.lang.value === 'ZH') {
            this.translatedFields = this.$store.state.translation_zh
          } else {
            this.translatedFields = this.fields_en
          }
        }
      }
    },
    computed: {
      language () {
        this.checkLanguage()
        return this.$store.state.lang.value
      },
      spanishFields () {
        return this.$store.state.translation_es
      },
      chineseFields () {
        return this.$store.state.translation_zh
      }
    },
    watch: {
      language () {
        this.checkLanguage()
      }
    }
  }
</script>
<style scoped>
  .htrx-secondary{
    color: #f4c617;
  }

  >>> .vue-form-wizard .wizard-icon-circle {
    background-color: white;
    color: #323737;
    border: 3px solid #323737;
  }

  >>> .vue-form-wizard .wizard-nav-pills>li>a {
    color: #323737;
  }

  >>> div[aria-selected="true"]{
    background-color: #31bebf !important;
  }

  >>> .wizard-card-footer {
    display: none;
  }

  @media (max-width: 400px) {
    >>> .vue-form-wizard .wizard-card-footer {
      display: -webkit-box;
      display: -moz-box;
      display: box;

      -webkit-box-orient: vertical;
      -moz-box-orient: vertical;
      box-orient: vertical;
    }

    >>> .vue-form-wizard .wizard-card-footer .wizard-footer-right {
      position: relative;
      min-height: 1px;
      width: 100%;
      margin-top: 10px;

      -webkit-box-ordinal-group: 1;
      -moz-box-ordinal-group: 1;
      box-ordinal-group: 1;
    }

    >>> .vue-form-wizard .wizard-card-footer .wizard-footer-left {
      position: relative;
      min-height: 1px;
      width: 100%;

      -webkit-box-ordinal-group: 2;
      -moz-box-ordinal-group: 2;
      box-ordinal-group: 2;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Homekit/RedirectHomekitWizard.vue